export default "__VITE_ASSET__D60$M8lG__"